import { getImageUrl, groupCoverImage, ideaCoverImage, userAvatarUrl } from "simplydo/core/images"
import { DefaultPreset } from "simplydo/react/richtext/Remirror/extensions/default"
import type { Preset } from "simplydo/react/richtext/Remirror/types"
import emojiData from "svgmoji/emoji.json"

const MinimalPreset: Preset = [
  ...DefaultPreset,
  {
    name: "mention",
    config: {
      name: "users",
      char: "@",
      filter: () => true, // skip frontend filter
      formatMention: (user) => ({
        href: `/users/${user._id}`,
        id: user._id,
        label: user?.profile?.fullName,
        description: user?.profile?.department || user?.profile?.jobTitle || "User",
        image: userAvatarUrl(user),
      }),
    },
  },
  {
    name: "mention",
    config: {
      name: "ideas",
      char: "$",
      filter: () => true, // skip frontend filter
      formatMention: (idea) => ({
        href: `/ideas/${idea._id}`,
        id: idea._id,
        label: idea?.name,
        description: "Idea",
        image: ideaCoverImage(idea),
      }),
    },
  },
  {
    name: "mention",
    config: {
      name: "challenges",
      char: "$",
      filter: () => true, // skip frontend filter
      formatMention: (challenge) => ({
        href: `/challenges/${challenge._id}`,
        id: challenge._id,
        label: challenge?.name,
        description: "Challenge",
        image: getImageUrl(challenge, ["coverImage", "bannerImage"], ["200x200"]),
      }),
    },
  },
  {
    name: "mention",
    config: {
      name: "groups",
      char: "$",
      filter: () => true, // skip frontend filter
      formatMention: (group) => ({
        href: `/groups/${group._id}`,
        id: group._id,
        label: group?.name,
        description: "Group",
        image: groupCoverImage(group),
      }),
    },
  },
  {
    name: "emoji",
    config: {
      data: emojiData,
      moji: "openmoji",
      suggestionCharacter: ":",
      plainText: true,
    },
  },
  {
    name: "link",
    config: {
      autoLink: true,
    },
  },
]

export default MinimalPreset
